import React, { useEffect, useMemo, useState, useRef } from "react";
import ChartNav from "../../../../common/ChartNav";
import Steps from "../../Steps";
import Button from "../../../../common/Button";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { updateMedicationReview } from "../../../../../redux/modules/clinical-services/actions";
import Medications from "../../medications/medications";
import {
  additionalMedications,
  AdherenceTypes,
  CommonQuestionValueTypes,
  DEFAULT_MEDICATION_TYPE_THERAPY,
} from "./data";
import SubNavigation from "../../common/sub-navigation";
import AdditionalMedicationCard from "./additionalMedicationCard";
import MedicationReviewCard from "./medicationReviewCard";
import { ReactSVG } from "react-svg";
import { drugTypes, reasonOptions } from "../clinical-assessment/data";
import { getValidStep } from "../../../text/data";
import ConfirmationModalNew from "../../../../common/ConfirmationModalNew";
import { calculateCenteredScrollPosition } from "../../../../../helpers/functions";
import { useMonographStatuses } from "../../../../../hooks/useMonographStatuses";

const MedicationChecklist = () => {
  const {
    medications,
    clinicalServiceObj,
    amrCurrentCard,
    amrClickedMedication,
    clinicalServiceSteps,
  } = useSelector((state) => state.clinicalService);
  const { currentStep, currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;
  const { id: patientId, serviceId } = useParams();
  const dispatch = useDispatch();

  const [completeSubStep, setCompleteSubStep] = useState(false);
  const [questionArray, setQuestionArray] = useState(additionalMedications);
  const [comments, setComments] = useState(null);
  const [reviewedMedicationCards, setReviewedMedicationCards] = useState([]);
  const [typedMedications, setTypedMedications] = useState([]);
  const [prescriptionReviewCards, setPrescriptionReviewCards] = useState([]);
  const [showCompliance, setShowCompliance] = useState(false);

  const [selectedCardIndex, setSelectedCardIndex] = useState(0);
  const selectedCardIndexRef = useRef(0);
  const pendingIndexRequestRef = useRef(null);
  const setSelectedCardIndexSafe = (newIndex) => {
    if (selectedCardIndexRef.current === newIndex) return;
    if (pendingIndexRequestRef.current === newIndex) return;
    pendingIndexRequestRef.current = newIndex;
    setSelectedCardIndex(newIndex);
  };
  const [updateState, setupdateState] = useState(true);
  const [markCardOptional, setMarkCardOptional] = useState([]);
  const [medCards, setMedCards] = useState([]);
  const [unsavedCards, setUnsavedCards] = useState([]);
  // profileAnalysisStatus: 'click_button' | 'completed'
  const [profileAnalysisStatus, setProfileAnalysisStatus] = useState("click_button");
  const [profileAnalysispopup, setProfileAnalysispopup] = useState(false);
  const [isAdditionalMedicationEditMode, setIsAdditionalMedicationEditMode] = useState(false);
  const selectedMedication = medCards[selectedCardIndex] || null;
  const monographIdentifiers = useMemo(
    () => typedMedications.map((med) => med?.medicationGenCode).filter(Boolean),
    [typedMedications]
  );
  const { data: monographStatusByIdentifier } =
    useMonographStatuses(monographIdentifiers);

  useEffect(() => {
    selectedCardIndexRef.current = selectedCardIndex;
    if (pendingIndexRequestRef.current === selectedCardIndex) {
      pendingIndexRequestRef.current = null;
    }
  }, [selectedCardIndex]);

  //------------------UseEffect Section - Loading and Updating UI---------------//
  // useEffect(() => {}, [selectedCardIndex]);
  //read state value and load initial data
  useEffect(() => {
    if (skipIndexResetRef.current) return;
    if (
      clinicalServiceObj.initialAssessment.initialAssessmentForm !== undefined
    ) {
      let reasons =
        clinicalServiceObj.initialAssessment.initialAssessmentForm.preAssessment
          .reasonsForMedicationReview;
      setShowCompliance(
        reasons.some((x) => x.includes("Initiate Compliance Packaging"))
      );
    }

    let obj =
      clinicalServiceObj.initialAssessment.initialAssessmentForm.medications;
    if (
      clinicalServiceObj.initialAssessment.initialAssessmentForm !==
        undefined &&
      obj !== null &&
      obj !== undefined
    ) {
      let arr = additionalMedications.map((item) => ({ ...item }));
      arr[0].isYes = obj.otherMedications;
      arr[1].isYes = obj.antibiotics;
      arr[2].isYes = obj.nonPrescriptionMedications;
      arr[3].isYes = obj.herbalsOrVitamins;
      arr[4].isYes = obj.miscellaneousMedications;
      arr[5].isYes = obj.medicationListComplete; // New sixth question
      setComments(obj.comments);
      setQuestionArray(arr);
      if (obj.additionaMedicationComplete === true) {
        setCompleteSubStep(true);
      }
      if (obj.profileAnalysisClicked === true) {
        setProfileAnalysisStatus("completed");
      } else {
        setProfileAnalysisStatus("click_button");
      }

      if (obj?.medications?.length > 0) {
        let cards = obj.medications.map((med) => {
                  const manufacturerName = med?.manufacturerName || typedMedications.find(m => m.id === med.medicationId)?.manufacturerName || "";
        const manufacturerStoredType = med?.manufacturerStoredType || typedMedications.find(m => m.id === med.medicationId)?.manufacturerStoredType || "";
        const manufacturerCode = med?.manufacturerCode || typedMedications.find(m => m.id === med.medicationId)?.manufacturerCode || "";
          if (typedMedications.map((x) => x.id).includes(med.medicationId))
            return {
              id: med.medicationId,
              name: "",
              cardName: "",
              reasonForMedication: med.reasonForMedicationName,
              reasonForMedicationCode: med.reasonsForMedicationGenCode,
              medicationType: med.medicationType,
              comment: med.comments,
              specialIntructions: med.specialIntructions,
              consumption: med.adherence,
              safe: med.safety,
              technique: med.properTechnique,
              working: med.effectiveness,
              interventionId: med?.interventionId,
              intervention: med?.intervention,
              status: med?.status,
              drugType: drugTypes.Additional,
              generalTime: med.generalTime ? med.generalTime : [],
                          manufacturerCode: manufacturerCode,
          manufacturerName: manufacturerName,
          manufacturerStoredType: manufacturerStoredType,
            };
          else
            return {
              id: med.medicationId,
              name: "",
              cardName: "",
              reasonForMedication: med.reasonForMedicationName,
              reasonForMedicationCode: med.reasonsForMedicationGenCode,
              medicationType: med.medicationType,
              comment: med.comments,
              specialIntructions: med.specialIntructions,
              consumption: med.adherence,
              safe: med.safety,
              technique: med.properTechnique,
              working: med.effectiveness,
              interventionId: med?.interventionId,
              intervention: med?.intervention,
              status: med?.status,
              drugType: drugTypes.Prescription,
              generalTime: med.generalTime ? med.generalTime : [],
                          manufacturerCode: manufacturerCode,
          manufacturerName: manufacturerName,
          manufacturerStoredType: manufacturerStoredType,
            };
        });

        let prescriptionCards = cards.filter(
          (x) => x.drugType === drugTypes.Prescription
        );
        setPrescriptionReviewCards(prescriptionCards);
        medications.forEach((med) => {
          const index = cards.findIndex((o) => o.id === med.id);
          if (index > -1) {
            cards[
              index
            ].name = `${med.medicationName} ${med.route} [${med.dosage} ${med.form} ${med.frequency}]`;
            cards[
              index
            ].cardName = `${med.medicationName} ${med.route} ${med.frequency}`;
          }
        });

        let additionalReviewCards = cards.filter((x) => x.drugType === drugTypes.Additional);
        setReviewedMedicationCards([...additionalReviewCards, ...prescriptionCards]);
        if (JSON.stringify(additionalReviewCards) !== JSON.stringify(medCards)) {
          setMedCards(additionalReviewCards);
        }
        
        const lastMedCardIndex = additionalReviewCards.length > 0 ? additionalReviewCards.length - 1 : 0;
        const initialCardIndex = amrCurrentCard !== null && amrCurrentCard < additionalReviewCards.length 
          ? amrCurrentCard 
          : lastMedCardIndex;
        const isOnMedicationCard = selectedCardIndex < additionalReviewCards.length;
        const hasUnreviewedActiveAdditionalMeds = typedMedications?.some(
          (med) =>
            med.status === "active" &&
            !additionalReviewCards.some((card) => card.name === med.displayName)
        );
        const shouldLandOnProfileCard =
          obj.additionaMedicationComplete === true && !hasUnreviewedActiveAdditionalMeds;

        if (!skipIndexResetRef.current) {
          if (shouldLandOnProfileCard) {
            const profileIndex = additionalReviewCards.length + 1;
            setSelectedCardIndexSafe(profileIndex);
          } else if (isOnMedicationCard) {
            setSelectedCardIndexSafe(initialCardIndex);
          }
        }
        
        requestAnimationFrame(() => {
          let remainingMeds = typedMedications?.filter(
            (x) =>
              x.status === "active" &&
              !additionalReviewCards.some((r) => r.name === x.displayName)
          );
          let allCardsReviewed = remainingMeds.length === 0;
          if (additionalReviewCards.length === 0 || !allCardsReviewed) {
            addBlankCard();
          }
        });
      }
      setupdateState(false);
    }
  }, [clinicalServiceObj, typedMedications]);

  //read medications and update UI
  useEffect(() => {
    setTypedMedications(
      medications.filter((x) => x.medicationType === drugTypes.Additional)
    );
  }, [medications]);

  // Ensure a blank card is available immediately when a new active Additional medication appears
  useEffect(() => {
    const activeCount = typedMedications.filter((x) => x.status === "active").length;
    if (completeSubStep) return; // do not add blank card after substep is completed
    if (activeCount > medCards.length) {
      addBlankCard();
    }
  }, [typedMedications, medCards.length]);

  useEffect(() => {
    if (
      typedMedications?.filter(
        (x) =>
          x.status === "inactive" &&
          medCards.map((c) => c.name).includes(x.displayName)
      ) &&
      medCards.length > 0
    ) {
      const inactiveMed = medCards.find((card) =>
        typedMedications
          ?.filter((x) => x.status === "inactive")
          .map((i) => i.displayName)
          .includes(card.name)
      );
      if (inactiveMed !== undefined) {
        const updatedMedCards = medCards.filter(
          (x) => x.name !== inactiveMed.name
        );
        setMedCards(updatedMedCards);
      }
    }
  }, [typedMedications]);

  //read cards update and set the view
  useEffect(() => {
    // if (medCards.length === 0) addBlankCard();
    if (TOTAL_CARDS > 0 && selectedCardIndex >= TOTAL_CARDS) {
      setSelectedCardIndexSafe(TOTAL_CARDS - 1);
    }

    setClickedCard();
  }, [medCards]);

  const setClickedCard = () => {
    //load the drug at the end, once the whole component is ready, read is there any clicked medication from prescription tab?
    if (medCards.length > 0 && amrClickedMedication !== null) {
      setTimeout(() => {
        //if yes select that drug from the reviewed card or load that drug on new blank card.
        selectMedication(amrClickedMedication);
        dispatch({
          type: "RESET_AMR_CLICKED_MEDICATION_LOCAL",
        });
      }, 1000);
    }
  };

  //------------------UseEffect Section - Loading and Updating UI---------------//

  //------------------Functions---------------//
  const getCardSize = () => {
    return showCompliance ? 1410 : 1050;
  };

  const PROFILE_CARD_WIDTH = 540;
  const CARD_MARGIN = 48; // must match calculateCenteredScrollPosition default

  const calculateFinalScrollForIndex = (index) => {
    if (!scrollContainerRef.current) return 0;
    const containerWidth = scrollContainerRef.current.clientWidth;
    const containerScrollWidth = scrollContainerRef.current.scrollWidth;
    const profileIndex = medCards.length + 1;
    const cardWidthForIndex =
      index === profileIndex ? PROFILE_CARD_WIDTH : getCardSize();
    const cardLeft = index === 0 ? 0 : index * getCardSize() + index * CARD_MARGIN;

    const containerCenter = containerWidth / 2;
    const target = cardLeft + cardWidthForIndex / 2 - containerCenter;
    const maxScroll = Math.max(0, containerScrollWidth - containerWidth);
    return Math.max(0, Math.min(target, maxScroll));
  };

  const TOTAL_CARDS = medCards.length + 1 + (completeSubStep ? 1 : 0);

  //Move Back and Forward
  const onNext = () => {
    if (currentStep <= clinicalServiceSteps.length) {
      const { nextStep, nextSubStep } = getValidStep(
        clinicalServiceSteps,
        currentStep,
        currentSubStep,
        1
      );

      dispatch({
        type: "RESET_AMR_CURRENT_REVIEWCARD_LOCAL",
      });
      let updatedMedications = onSaveProgress(nextStep, nextSubStep);

      dispatch({
        type: "SET_AMR_INITIAL_VALUE_REVIEWCARDS_LOCAL",
        payload: [],
      });
      dispatch({
        type: "SET_AMR_UPDATED_REVIEWCARDS_LOCAL",
        payload: [],
      });
    }
  };

  const onPrevious = () => {
    const { nextStep, nextSubStep } = getValidStep(
      clinicalServiceSteps,
      currentStep,
      currentSubStep,
      -1
    );
    dispatch({
      type: "RESET_AMR_CURRENT_REVIEWCARD_LOCAL",
    });
    dispatch({
      type: "SET_AMR_INITIAL_VALUE_REVIEWCARDS_LOCAL",
      payload: [],
    });
    dispatch({
      type: "SET_AMR_UPDATED_REVIEWCARDS_LOCAL",
      payload: [],
    });
    const updatedSteps = { currentStep: nextStep, currentSubStep: nextSubStep };
    dispatch(updateMedicationReview(serviceId, updatedSteps));
  };

  //save progress on each card update
  const onSaveProgress = (nextStep, nextSubStep, cards = medCards) => {
    const cardUpdatesMade =
      currentStep === nextStep && currentSubStep === nextSubStep;
    const updatedMedications = cards
      .filter((x) => x && x.id !== -1)
      .map((med) => {
        return {
          medicationId: med.id,
          reasonForMedicationName: med.reasonForMedication,
          reasonsForMedicationGenCode: med?.reasonForMedicationCode,
          medicationType: med.medicationType,
          comments: med.comment,
          specialIntructions: med.specialIntructions,
          adherence: med.consumption,
          safety: med.safe,
          properTechnique: med.technique,
          effectiveness: med.working,
          interventionId: med?.interventionId,
          intervention: med?.intervention,
          status: med?.status,
          generalTime: med?.generalTime,
        };
      });

    const prescriptionCards = prescriptionReviewCards.map((med) => {
      return {
        medicationId: med.id,
        reasonForMedicationName: med.reasonForMedication,
        reasonsForMedicationGenCode: med?.reasonForMedicationCode,
        medicationType: med.medicationType,
        comments: med.comment,
        specialIntructions: med.specialIntructions,
        adherence: med.consumption,
        safety: med.safe,
        properTechnique: med.technique,
        effectiveness: med.working,
        interventionId: med?.interventionId,
        intervention: med?.intervention,
        status: med?.status,
        generalTime: med?.generalTime,
      };
    });
    const updatedClinicalServiceObj = {
      medications: {
        medications: [...prescriptionCards, ...updatedMedications],
        otherMedications: questionArray[0].isYes,
        antibiotics: questionArray[1].isYes,
        nonPrescriptionMedications: questionArray[2].isYes,
        herbalsOrVitamins: questionArray[3].isYes,
        miscellaneousMedications: questionArray[4].isYes,
        medicationListComplete: questionArray[5].isYes, // New sixth question
        comments: comments,
        additionaMedicationComplete: completeSubStep,
        profileAnalysisClicked: cardUpdatesMade
          ? false
          : clinicalServiceObj?.initialAssessment?.initialAssessmentForm?.medications
              ?.profileAnalysisClicked,
      },
      currentStep: nextStep,
      currentSubStep: nextSubStep,
    };
    dispatch(updateMedicationReview(serviceId, updatedClinicalServiceObj));

    return updatedMedications;
  };

  const onSaveAdditionalMedication = (arr, comments) => {
    if (arr && arr.length > 0) {
      setQuestionArray(arr.map((item) => ({ ...item })));
      setComments(comments);
      setCompleteSubStep(true);
      // Mark profile analysis as needing re-run after additional meds saved
      if (profileAnalysisStatus === "completed") {
        setProfileAnalysisStatus("click_button");
      }
      setIsAdditionalMedicationEditMode(false);
      const additionalMedicationsPayload = {
        otherMedications: arr[0].isYes,
        antibiotics: arr[1].isYes,
        nonPrescriptionMedications: arr[2].isYes,
        herbalsOrVitamins: arr[3].isYes,
        miscellaneousMedications: arr[4].isYes,
        comments: comments,
        medicationListComplete: arr[5]?.isYes,
        additionaMedicationComplete: true,
      };
      const updatedClinicalServiceObj = {
        medications: {
          ...additionalMedicationsPayload,
          profileAnalysisClicked: false,
        },
        currentStep: currentStep,
        currentSubStep: currentSubStep,
      };
      // Prevent the initial-load effect from overriding our programmatic navigation
      skipIndexResetRef.current = true;
      dispatch(updateMedicationReview(serviceId, updatedClinicalServiceObj));
      dispatch({
        type: "SET_AMR_ADDITIONAL_MEDICATIONS_LOCAL",
        payload: additionalMedicationsPayload,
      });

      // Move selection to the Profile Analysis card (index after additional card)
      const profileIndex = medCards.length + 1;
      moveToProfileAnalysisCard(profileIndex);
    }
  };

  const [isOverflowing, setIsOverflowing] = useState(false);
  const scrollContainerRef = useRef(null);
  const cardRefs = useRef([]);
  const skipIndexResetRef = useRef(false);
  const pendingCenteredScrollIndexRef = useRef(null);
  const releaseSkipIndexResetAfterScrollRef = useRef(false);

  const moveToProfileAnalysisCard = (profileIndex) => {
    skipIndexResetRef.current = true;
    pendingCenteredScrollIndexRef.current = profileIndex;
    releaseSkipIndexResetAfterScrollRef.current = true;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setSelectedCardIndexSafe(profileIndex);
      });
    });
  };

  useEffect(() => {
    const el = scrollContainerRef.current;
    if (!el) return;

    const updateOverflow = () => {
      setIsOverflowing(el.scrollWidth > el.clientWidth);
    };

    updateOverflow();
    window.addEventListener("resize", updateOverflow);
    return () => window.removeEventListener("resize", updateOverflow);
  }, [medCards.length]);

  useEffect(() => {
    const el = scrollContainerRef.current;
    if (!el) return;

    const shouldForceScroll =
      pendingCenteredScrollIndexRef.current === selectedCardIndex;

    if (skipIndexResetRef.current && !shouldForceScroll) return;

    const profileIndex = medCards.length + 1;

    const finalScroll =
      selectedCardIndex === profileIndex
        ? calculateFinalScrollForIndex(selectedCardIndex)
        : calculateCenteredScrollPosition(
            selectedCardIndex,
            getCardSize(),
            el.clientWidth,
            el.scrollWidth
          );

    requestAnimationFrame(() => {
      el.scrollTo({
        left: finalScroll,
        behavior: "smooth",
      });

      if (shouldForceScroll) {
        pendingCenteredScrollIndexRef.current = null;
      }

      if (releaseSkipIndexResetAfterScrollRef.current) {
        releaseSkipIndexResetAfterScrollRef.current = false;
        requestAnimationFrame(() => {
          skipIndexResetRef.current = false;
        });
      }
    });
  }, [selectedCardIndex, medCards.length, completeSubStep]);

  const updateReviewedCards = (reviewedMed) => {
    if (!reviewedMedicationCards.some((i) => i.name === reviewedMed.name)) {
      setReviewedMedicationCards([...reviewedMedicationCards, reviewedMed]);
    } else {
      setReviewedMedicationCards([
        ...reviewedMedicationCards.filter((x) => x.name !== reviewedMed.name),
        reviewedMed,
      ]);
    }
  };

  const addBlankCard = () => {
    const activeMedicationCount = typedMedications.filter(
      (x) => x.status === "active"
    ).length;

    if (updateState || activeMedicationCount <= medCards.length) return;

    const existingBlankIndex = medCards.findIndex(
      (card) => card.id === -1 || card.status === "blank"
    );

    const nextSelectedIndex =
      existingBlankIndex >= 0 ? existingBlankIndex : medCards.length;

    if (existingBlankIndex < 0) {
      skipIndexResetRef.current = true;
      pendingCenteredScrollIndexRef.current = nextSelectedIndex;
      releaseSkipIndexResetAfterScrollRef.current = true;

      const obj = {
        id: -1,
        name: null,
        cardName: null,
        reasonForMedication: null,
        reasonForMedicationCode: null,
        consumption: null,
        working: null,
        safe: null,
        medicationType: DEFAULT_MEDICATION_TYPE_THERAPY,
        technique: null,
        comment: null,
        specialIntructions: null,
        interventionId: null,
        intervention: null,
        status: "blank",
        generalTime: [],
      };

      setMedCards((prev) => [...prev, obj]);
      setSelectedCardIndexSafe(nextSelectedIndex);
    } else if (selectedCardIndex !== nextSelectedIndex) {
      skipIndexResetRef.current = true;
      pendingCenteredScrollIndexRef.current = nextSelectedIndex;
      releaseSkipIndexResetAfterScrollRef.current = true;
      setSelectedCardIndexSafe(nextSelectedIndex);
    }

    if (profileAnalysisStatus === "completed") {
      setProfileAnalysisStatus("click_button");
    }
  };

  const selectMedication = (selectedDrug) => {
    const existingIndex = medCards.findIndex(
      (card) => card.name === selectedDrug.displayName
    );

    if (existingIndex >= 0) {
      moveToCard(existingIndex);
      return;
    }

    const blankCardIndex = medCards.findIndex((card) => card.status === "blank");
    
    if (blankCardIndex >= 0) {
      const reason = {
        label: reasonOptions.find((r) => r.value === selectedDrug.reason)?.label || selectedDrug.reason,
        value: selectedDrug.reason,
      };
      
      const selectedDrugCard = {
        ...medCards[blankCardIndex],
        name: selectedDrug.displayName,
        cardName: `${selectedDrug.medicationName} ${selectedDrug.route} ${selectedDrug.frequency}`,
        id: selectedDrug.id,
        reasonForMedication: reason.label,
        reasonForMedicationCode: reason.value,
        comments: selectedDrug.comments,
        specialIntructions: selectedDrug.comments,
        consumption: AdherenceTypes.AsPrescribed,
        safe: CommonQuestionValueTypes.No,
        working: CommonQuestionValueTypes.Yes,
        technique: selectedDrug.displayName?.toLowerCase().includes("nhl")
          ? CommonQuestionValueTypes.Yes
          : CommonQuestionValueTypes.NotSure,
        manufacturerCode: selectedDrug?.manufacturerCode,
        manufacturerName: selectedDrug?.manufacturerName,
        manufacturerStoredType: selectedDrug?.manufacturerStoredType,
      };
      
      const updatedMedCards = [...medCards];
      updatedMedCards[blankCardIndex] = selectedDrugCard;
      setMedCards(updatedMedCards);
      if (profileAnalysisStatus === "completed") {
        setProfileAnalysisStatus("click_button");
      }
      setSelectedCardIndexSafe(blankCardIndex);
    } else if (medCards.length > 0) {
      moveToCard(medCards.length - 1);
    }
  };

  const MoveToPrescriptionMedication = (selectedDrug) => {
    if (unsavedCards.length === 0) {
      dispatch({
        type: "SET_AMR_CLICKED_MEDICATION_LOCAL",
        payload: selectedDrug,
      });
      onPrevious();
    }
  };

  const moveToCard = (index) => {
    if (selectedCardIndex === index) return;
    setSelectedCardIndexSafe(index);
  };

  const moveNext = () => {
    if (selectedCardIndex < TOTAL_CARDS - 1) {
      const newIndex = selectedCardIndex + 1;
      setSelectedCardIndexSafe(newIndex);
    }
  };

  const handleMedicationCardMovement = (allMedicationReviewed) => {
    if (!allMedicationReviewed) {
      addBlankCard();
    }
  };

  const handleCardNavigationAfterSave = () => {
    let nextIndex = selectedCardIndex;

    if (selectedCardIndex === medCards.length - 1) {
      nextIndex = completeSubStep ? medCards.length + 1 : medCards.length;
    } else if (selectedCardIndex < TOTAL_CARDS - 1) {
      nextIndex = selectedCardIndex + 1;
    }

    if (nextIndex === selectedCardIndex) return;

    skipIndexResetRef.current = true;
    pendingCenteredScrollIndexRef.current = nextIndex;
    releaseSkipIndexResetAfterScrollRef.current = true;
    setSelectedCardIndexSafe(nextIndex);
  };

  const onContinue = (reviewedMed) => {
    dispatch({
      type: "UPDATE_AMR_CURRENT_REVIEWCARD_LOCAL",
      payload: selectedCardIndex,
    });

    updateReviewedCards(reviewedMed);
    const updatedCards = [...medCards];
    updatedCards[selectedCardIndex] = reviewedMed;
    setMedCards((prev) => {
      const updated = [...prev];
      updated[selectedCardIndex] = reviewedMed;
      return updated;
    });
    if (profileAnalysisStatus === "completed") {
      setProfileAnalysisStatus("click_button");
    }
    onSaveProgress(currentStep, currentSubStep, updatedCards);
    handleCardNavigationAfterSave();
  };

  const onSkipReview = (updatedMed) => {
    dispatch({
      type: "UPDATE_AMR_CURRENT_REVIEWCARD_LOCAL",
      payload: selectedCardIndex,
    });
    setMarkCardOptional((prev) => [...prev, updatedMed.id]);
    const updatedCards = [...medCards];
    updatedCards[selectedCardIndex] = updatedMed;
    setMedCards((prev) => {
      const updated = [...prev];
      updated[selectedCardIndex] = updatedMed;
      return updated;
    });
    updateReviewedCards(updatedMed);
    if (profileAnalysisStatus === "completed") {
      setProfileAnalysisStatus("click_button");
    }
    onSaveProgress(currentStep, currentSubStep, updatedCards);
    handleCardNavigationAfterSave();
  };

  const onRevertSkip = (updatedMed) => {
    if (markCardOptional.includes(updatedMed.id)) {
      setMarkCardOptional(
        markCardOptional.filter((item) => item !== updatedMed.id)
      );
    }
    setMedCards((prev) => {
      const updated = [...prev];
      updated[selectedCardIndex] = updatedMed;
      return updated;
    });
    if (profileAnalysisStatus === "completed") {
      setProfileAnalysisStatus("click_button");
    }
  };

  const deleteCurrentCard = (index) => {
    setReviewedMedicationCards(
      reviewedMedicationCards.filter((x) => x.name !== medCards[index].name)
    );

    setMedCards((prev) => prev.filter((_, i) => i !== index));
    if (profileAnalysisStatus === "completed") {
      setProfileAnalysisStatus("click_button");
    }
    onSaveProgress(currentStep, currentSubStep);
  };
  //------------------Functions---------------//

  return (
  <>
    <div className="flex flex-col flex-1 gap-4 bg-white">
      <div className="flex flex-col flex-1">
        <div className="flex flex-1 gap-4">
          <ChartNav />
          <Medications
            isAMR={true}
            showMedication={true}
            isAdditional={true}
            reviewedMedicationCards={reviewedMedicationCards}
            selectMedication={(val) => {
              if (val.medicationType === drugTypes.Prescription)
                MoveToPrescriptionMedication(val);
              else selectMedication(val);
            }}
            checkLastMedication={(isLast) => {
              handleMedicationCardMovement(isLast);
            }}
            selectedMedication={selectedMedication}
            defaultExpandedSection="additional"
          />
          <div className="flex flex-1 w-full min-h-[660px] overflow-hidden">
            <div className="w-full gap-5 h-full">
              <div className="flex items-center justify-between mt-0.5 mb-0.5">
                <h4 className="text-2xl font-bold text-teal-600">
                  Annual Medication Review - Additional Medications
                </h4>
                <SubNavigation />
              </div>
              <div className="border-b-[7px] border-gray-20 mb-[20px]"></div>

                    <div
                      ref={scrollContainerRef}
                      className="flex w-full overflow-x-auto overflow-y-hidden scroll-smooth"
                      id="review"
                    >
                      {typedMedications.length > 0 &&
                        medCards.map((med, i) => (
                          med ? (
                          <React.Fragment key={med?.id != null ? `${med.id}-${i}` : `blank-${i}`}>                                                  
                            {isOverflowing &&
                              i === selectedCardIndex &&
                              selectedCardIndex !== 0 && (
                                <button
                                  className="flex flex-row bg-gray-20 w-[36px] h-[62px] my-auto pb-[18px] mx-10 px-[10px] text-teal-600 font-bold"
                                  onClick={() => setSelectedCardIndexSafe(selectedCardIndex - 1)}
                                >
                                  <ReactSVG
                                    src="/icons/arrow-right.svg"
                                    className="w-[15px] rotate-180"
                                  />
                                </button>
                              )}

                            <div ref={(el) => (cardRefs.current[i] = el)} className="flex-none w-[1050px] px-6 box-border">
                              <MedicationReviewCard
                                medication={med}
                                medications={typedMedications}
                                patientId={patientId}
                                onFocus={i === selectedCardIndex}
                                monographStatusByIdentifier={monographStatusByIdentifier}
                                saveCard={(medCard) => onContinue(medCard)}
                                skipCard={(medCard) => onSkipReview(medCard)}
                                revertSkipCard={(medCard) => onRevertSkip(medCard)}
                                deleteCard={() => deleteCurrentCard(i)}
                                moveToCard={() => moveToCard(i)}
                                updateUnsavedCard={(isUnsaved) => {
                                  setUnsavedCards((prev) => {
                                    if (isUnsaved && !prev.includes(i)) {
                                      return [...prev, i];
                                    }
                                    if (!isUnsaved) {
                                      return prev.filter((x) => x !== i);
                                    }
                                    return prev;
                                  });
                                }}
                                showCompliance={showCompliance}
                              />
                              </div>

                            {isOverflowing &&
                              i === selectedCardIndex &&
                              selectedCardIndex !== TOTAL_CARDS - 1 && (
                                <button
                                  className="flex flex-row bg-gray-20 w-[36px] h-[62px] my-auto pt-[18px] mx-10 px-[10px] text-teal-600 font-bold"
                                  onClick={() => setSelectedCardIndexSafe(selectedCardIndex + 1)}
                                >
                                  <ReactSVG
                                    src="/icons/arrow-right.svg"
                                    className="w-[15px]"
                                  />
                                </button>
                              )}
                          </React.Fragment>
                          ) : null
                        ))}

                        {selectedCardIndex !== 0 && selectedCardIndex >= medCards.length && (
                          <button
                            className="flex flex-row bg-gray-20 w-[36px] h-[62px] my-auto pb-[18px] mx-10 px-[10px] text-teal-600 font-bold"
                            onClick={() => setSelectedCardIndexSafe(selectedCardIndex - 1)}
                          >
                            <ReactSVG
                              src="/icons/arrow-right.svg"
                              className="w-[15px] rotate-180"
                            />
                          </button>
                        )}
                        <div
                          ref={(el) => (cardRefs.current[medCards.length] = el)}
                          className={`flex-none px-6 box-border ${
                            showCompliance ? "w-[1410px]" : "w-[1050px]"
                          }`}
                        >
                          <AdditionalMedicationCard
                            medicationCheckListData={questionArray}
                            onFocus={true}
                            patientId={patientId}
                            initialComments={comments}
                            isCompleted={completeSubStep}
                            forceDisabled={
                              completeSubStep && !isAdditionalMedicationEditMode
                            }
                            onEditModeChange={(isEditMode) =>
                              setIsAdditionalMedicationEditMode(isEditMode)
                            }
                            completeAnalysis={(obj) =>
                              onSaveAdditionalMedication(obj.arr, obj.comments)
                            }
                          />
                        </div>

                        {completeSubStep && (
                          <div
                            ref={(el) => (cardRefs.current[medCards.length + 1] = el)}
                            className="flex-none w-[480px] px-6 box-border"
                          >
                            <div className="h-[600px] rounded-[4px] flex flex-col overflow-hidden border border-gray-100">
                              <div className="h-[420px] w-[420px] rounded-full mx-auto my-8 bg-gray-50 bg-opacity-40 flex items-center justify-center relative">
                                <ReactSVG
                                  src="/icons/profile-analysis-p1.svg"
                                  className="absolute left-[28%] top-[20%]"
                                />
                                <ReactSVG
                                  src="/icons/profile-analysis-p2.svg"
                                  className="absolute top-[25%] left-[41%]"
                                />
                                <p className="absolute bottom-[10%] left-24 text-teal-600 text-xl font-normal">
                                  Powered by RxVigilance
                                </p>
                              </div>
                              <div className="mx-7 mt-10 mb-5">
                                {!isAdditionalMedicationEditMode && profileAnalysisStatus !== "completed" && (
                                  <Button
                                    className="w-full !px-2 !text-xl"
                                    type="primary"
                                    text="Profile Analysis"
                                    onClick={() => {
                                      setProfileAnalysispopup(true);
                                    }}
                                  />
                                )}
                                {!isAdditionalMedicationEditMode && profileAnalysisStatus === "completed" && (
                                  <h4 className="text-xl text-REELTeal font-bold items-center justify-center flex">
                                    Profile Analysis Coming Soon!
                                  </h4>
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                      {/* Profile analysis card moved into the index-based card flow */}
                    </div>
              </div>
            </div>
            <ConfirmationModalNew
              className="!min-w-[550px]"
              type="primary"
              title="Powered by RxVigilance - Coming Soon!"
              content={() => (
                <div className="flex flex-col gap-4">
                  <p className="text-body-md text-gray-600 font-medium">
                    Profile analysis tool can be used to generate numerous
                    alerts to identify potential problems.
                  </p>
                </div>
              )}
              confirmText={"Continue to Review"}
              confirmAction={() => {
                setProfileAnalysispopup(false);
                setProfileAnalysisStatus("completed");

                // Ensure we preserve all existing medication data
                const existingMedications = clinicalServiceObj?.initialAssessment?.initialAssessmentForm?.medications || {};
                const updatedClinicalServiceObj = {
                  medications: {
                    ...existingMedications,
                    profileAnalysisClicked: true,
                  },
                  currentStep: currentStep,
                  currentSubStep: currentSubStep,
                };
                dispatch(updateMedicationReview(serviceId, updatedClinicalServiceObj));

                const profileIndex = medCards.length + 1;
                moveToProfileAnalysisCard(profileIndex);
              }}
              open={profileAnalysispopup}
              handleClose={() => {
                setProfileAnalysispopup(false);
              }}
              onCross={() => {
                setProfileAnalysispopup(false);
              }}
            />
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between space-x-4  rounded">
        <div className="w-full ">
          <Steps position="bottom" stepsList={clinicalServiceSteps} />
        </div>
        <div className="flex items-center gap-3 ">
          <Button
            type="primary-outline"
            text="Back"
            className="w-[200px] max-h-[52px] !rounded-[30px]"
            onClick={() => onPrevious()}
          />
          <Button
            type="primary"
            text="Next"
            className={`w-[200px] max-h-[52px] !rounded-[30px] ${
              (profileAnalysisStatus !== "completed" || !completeSubStep) &&
              "opacity-40 pointer-events-none"
            }`}
            onClick={() => onNext()}
          />
        </div>
    </div>
  </>
  );
};

export default MedicationChecklist;
